import React, { FC } from "react";
import cn from "classnames";
import styled from "styled-components";

interface Props {
    justify?: string;
    align?: string;
    className?: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    reff?: any;
    wrap?:
        | "wrap"
        | "nowrap"
        | "-moz-initial"
        | "inherit"
        | "initial"
        | "revert"
        | "unset"
        | "wrap-reverse";
    gap?: string;
}

const Row: FC<Props> = ({
    justify,
    align,
    className,
    wrap,
    gap,
    onClick,
    reff,
    ...props
}) => {
    const style = {
        justifyContent: justify || "flex-start",
        alignItems: align || "stretch",
        flexWrap: wrap || "nowrap",
        margin: `-${gap}` || "0",
    };
    return (
        <StyledDiv
            className={cn("row", className)}
            style={style}
            onClick={onClick}
            ref={reff}
            gap={gap}
        >
            {props.children}
        </StyledDiv>
    );
};

const StyledDiv = styled(({ gap, ...otherProps }) => <div {...otherProps} />)`
    & > .col {
        margin: ${(props) => props.gap} !important;
    }
`;

export default Row;
